import SideNav, { SideNavItem } from 'app/common/ui/SideNav'
import CSSSticky from 'app/common/ui-components/css-sticky'
import PlainIcon from 'app/common/ui-next/plain-icon'
import { useVendingMachineSingle } from 'app/dataProviders/VendingDataProvider'

import ContentView from './ContentView'
import { availableSections, defaultSection, sectionIcons, sectionTitles, type Section } from './sections'

import styles from './SettingSection.scss'

interface Props {
  type?: string
  basePath: string
}

export const SettingSection = ({ type, basePath }: Props) => {
  const [{ orgId }] = useVendingMachineSingle()
  const currentType = availableSections.includes(type as Section)
    ? (type as Section)
    : defaultSection

  return (
    <div className={styles.container}>
      <CSSSticky className={styles.stickable} number={3}>
        <SideNav>
          {availableSections.map((key) => (
            <SideNavItem
              key={key}
              title={sectionTitles[key]}
              to={`${basePath}/${key}`}
              active={currentType === key}
            >
              <PlainIcon type={sectionIcons[key]} />
            </SideNavItem>
          ))}
        </SideNav>
      </CSSSticky>

      <div className={styles.content}>
        <ContentView
          type={currentType}
          orgId={orgId}
        />
      </div>
    </div>
  )
}
